import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export const TravelButton = () => {
  return (
    <Link to="/travel-direction" className="w-full sm:w-auto">
      <motion.div
        className="relative group"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        aria-label="यात्रा का दिशा शूल देखें"
      >
        <div className="relative px-8 py-4 bg-gradient-to-r from-yellow-400 to-yellow-500 rounded-lg overflow-hidden w-full flex items-center justify-center gap-2">
          <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
          <span className="relative text-2xl font-bold text-gray-900 whitespace-nowrap">
            यात्रा का दिशा शूल
          </span>
          <ArrowRight className="w-6 h-6" />
        </div>
        
        <div className="absolute inset-0 bg-yellow-300 opacity-0 group-hover:opacity-20 rounded-lg filter blur-xl transition-opacity duration-300"></div>
      </motion.div>
    </Link>
  );
};